export const ogIncludeMetaTypeArray = [
  'about',
  'home-equity-loan',
  'personal-loans',
  'debt-relief',
  'learn',
  'dollars-sense',
]

export const ogIncludeMetaTypeArticleArray = ['learn', 'dollars-sense', 'blog']
